import React from "react";
import { NavLink } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { FaList } from "react-icons/fa";
import { GoProjectSymlink } from "react-icons/go";
import { RiFundsBoxFill } from "react-icons/ri";
import { FaUsers } from "react-icons/fa";
import {
  Dashboard, DashboardActive, Lenders, LendersActive, Borrowers, BorrowersActive,
  Projects, ProjectsActive, NewDealsProject, NewDealsProjectActive, InterestedUser, InterestedUserActive,
  FundingSecured, FundingSecuredActive, UpdatePassword, UpdatePasswordActive, DealsMarked, DealsMarkedActive,
  NewMatchesCreated, NewMatchesCreatedActive, AdminsActive, Admins, TCPurchases, TCPurchasesActive, DealsAssigned, DealsAssignedActive
} from "./svg/Svg";

const LeftbarAdmin = ({ handleSidebarClose, customClass }) => {
  const role = localStorage.getItem("role");

  const NAV_ITEMS = [
    {
      label: "Dashboard",
      path: "/dashboard",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Dashboard,
      ActiveIcon: DashboardActive,
      iconProps: { width: "22px", height: "22px" },
    },
    {
      label: "Lenders",
      path: "/lender",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Lenders,
      ActiveIcon: LendersActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Borrowers",
      path: "/borrower",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Borrowers,
      ActiveIcon: BorrowersActive,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      label: "Background Checks",
      path: "/background-check",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Borrowers,
      ActiveIcon: BorrowersActive,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      label: "Admin",
      path: "/admin",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Admins,
      ActiveIcon: AdminsActive,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      label: "Free Trials",
      path: "/free-trials",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Borrowers,
      ActiveIcon: BorrowersActive,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      label: "Projects",
      path: "/projects",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: Projects,
      ActiveIcon: ProjectsActive,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      label: "Resources",
      path: "/resources",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: DealsAssigned,
      ActiveIcon: DealsAssignedActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Blog",
      path: "/blogs",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: DealsAssigned,
      ActiveIcon: DealsAssignedActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Resources Category",
      path: "/resource-category",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: DealsAssigned,
      ActiveIcon: DealsAssignedActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "TC Purchases",
      path: "/tc-purchase",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: TCPurchases,
      ActiveIcon: TCPurchasesActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Deals Assigned",
      path: "/deals-assigned",
      roles: ["transaction_cordinator"],
      Icon: DealsAssigned,
      ActiveIcon: DealsAssignedActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Lender Ratings",
      path: "/lender-ratings",
      roles: ["super_admin", "admin", "virtual_assistant", "transaction_cordinator"],
      Icon: Lenders,
      ActiveIcon: LendersActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Borrower Ratings",
      path: "/borrower-ratings",
      roles: ["super_admin", "admin", "virtual_assistant", "transaction_cordinator"],
      Icon: Borrowers,
      ActiveIcon: BorrowersActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "New Matches Created",
      path: "/newmatches",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: NewMatchesCreated,
      ActiveIcon: NewMatchesCreatedActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Pending Funding",
      path: "/dealsmarked",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: DealsMarked,
      ActiveIcon: DealsMarkedActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "New Deals",
      path: "/new-project-deals",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: NewDealsProject,
      ActiveIcon: NewDealsProjectActive,
      iconProps: { width: "24px", height: "24px" },
    },
    {
      label: "Interested Lenders",
      path: "/interested-user",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: InterestedUser,
      ActiveIcon: InterestedUserActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Funded Projects",
      path: "/fundsecure-list",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: FundingSecured,
      ActiveIcon: FundingSecuredActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Match to funding",
      path: "/matching-conversion",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: FundingSecured,
      ActiveIcon: FundingSecuredActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Notification",
      path: "/notification",
      roles: ["super_admin", "admin", "virtual_assistant"],
      Icon: FundingSecured,
      ActiveIcon: FundingSecuredActive,
      iconProps: { width: "26px", height: "26px" },
    },
    {
      label: "Update Profile",
      path: "/update-profile",
      roles: ["super_admin", "admin", "virtual_assistant", "transaction_cordinator"],
      Icon: UpdatePassword,
      ActiveIcon: UpdatePasswordActive,
      iconProps: { width: "26px", height: "26px" },
    },
  ];

  const visibleNavItems = NAV_ITEMS.filter(item =>
    item.roles.includes(role)
  );

  return (
    <>
      <aside className={`sidenav navbar navbar-vertical navbar-expand-xs fixed-left  ${customClass}`}>
        <div className="sidenav-header">
          <div className="navbar-brand m-0">
            <img
              src="/img/StrideCapitalLogo.png"
              className="navbar-brand-img h-100 w-100"
              alt="Logo"
              style={{ marginRight: "8px" }}
            />
          </div>
          <div>
          </div>
        </div>
        <div className="collapse navbar-collapse  w-auto">
          <ul className="navbar-nav">
            {visibleNavItems.map((item) => (
              <li
                key={item.path}
                className="nav-item"
                onClick={handleSidebarClose}
              >
                <NavLink
                  to={item.path}
                  className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                >
                  {({ isActive }) => (
                    <>
                      {isActive ? (
                        <item.ActiveIcon {...item.iconProps} />
                      ) : (
                        <item.Icon {...item.iconProps} />
                      )}
                      <span
                        className="nav-link-text"
                        style={{
                          marginLeft: "8px",
                          color: isActive ? "#ffffff" : "#6C757D",
                        }}
                      >
                        {item.label}
                      </span>
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </>
  );
};


export default LeftbarAdmin;